<template>
  <section class="approvalInfoModify">
    <viewTitle
      class="viewTitle"
      title="业务管理 / 审批跳过情况汇总 / 消息管理 / 消息详情"
      :showReturn="true"
    />
    <div class="listAdmin">
      <el-form label-width="120px" style="width: 550px;" label-position="left">
        <el-form-item label="发送范围：">
          <div v-if="listSuperAdmin.org.length > 0">
            部门：
            <span
              v-for="(item, index) in listSuperAdmin.org"
              :key="index"
              style="display: inline-block;"
            >
              {{ item.name }}
              <span v-if="index !== listSuperAdmin.org.length - 1">、</span>
            </span>
          </div>
          <!-- <div v-if="listSuperAdmin.group.length > 0">
            分组：
            <span
              v-for="(item, index) in listSuperAdmin.group"
              :key="index"
              style="display: inline-block;"
            >
              {{ item.name }}
              <span v-if="index !== listSuperAdmin.group.length - 1">、</span>
            </span>
          </div> -->
          <div v-if="listSuperAdmin.user.length > 0">
            人员：
            <span
              v-for="(item, index) in listSuperAdmin.user"
              :key="index"
              style="display: inline-block;"
            >
              {{ item.name }}
              <span v-if="index !== listSuperAdmin.user.length - 1">、</span>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="消息类别：">
          {{ params.class_name }}
        </el-form-item>
        <el-form-item label="消息标题：">
          {{ params.title }}
        </el-form-item>
        <el-form-item label="导入文件：">
          <div>
            <table
              style="border-collapse: collapse;width: calc(100vw - 500px);"
            >
              <tr>
                <td
                  style="word-break: keep-all;border: 1px solid #eee;padding:4px 8px;font-weight: bold;"
                  v-for="(item, index) in excelCont.header"
                  :key="index"
                >
                  {{ item }}
                </td>
              </tr>
              <tr v-for="(item, index) in excelCont.items" :key="index">
                <td
                  style="word-break: keep-all;border: 1px solid #eee;padding:4px;word-wrap:break-word;word-break:break-all;line-height: 20px;"
                  v-for="(itemTd, indexi) in item"
                  :key="indexi"
                >
                  {{ itemTd }}
                </td>
              </tr>
            </table>
          </div>
        </el-form-item>
        <el-form-item label="定时发送时间">
          {{
            params.publish_timing > 0 ? formatTime(params.publish_timing) : "--"
          }}
        </el-form-item>
      </el-form>
      <div class="mt30">
        <el-button type="primary" @click="onPre" size="small">
          扫码预览
        </el-button>
        <el-button type="primary" @click="modifyInfo" size="small">
          再次发送
        </el-button>
        <el-button
          size="small"
          type="danger"
          @click="dialogParams.show = true"
          style="color: white;"
        >
          删除
        </el-button>
      </div>
    </div>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="qrCodeShow"
      width="30%"
      :show-close="false"
      title="扫描二维码预览"
      :close-on-click-modal="false"
    >
      <div style="display: flex;justify-content: center;">
        <div id="qrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeShow = false" size="small">
          <span>关 闭</span>
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      title="确认提醒"
      :close-on-click-modal="false"
    >
      <div>
        <span class="color67">确认要删除数据吗？删除后不可恢复！</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span>取消</span>
        </el-button>
        <el-button type="danger" @click="confirmDel" size="small">
          <span>确定</span>
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import viewTitle from "@/components/viewTitle";
import QRCode from "qrcodejs2";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";

export default {
  data() {
    return {
      deptListObj: {
        title: "选择发送范围",
        model: "bothAll",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false,
        urlType: "sysAdmin"
      },
      listSuperAdmin: { org: [], group: [], user: [] },
      params: {
        class_id: "", // 分类记录id
        title: "", // 消息标题
        publish_timing: "", // 定时发送时间
        file: {},
        class_name: ""
      },
      dialogParams: {
        show: false,
        content: ""
      },
      categoryOptions: [],
      preDomCreat: false,
      preExcleDom: false,
      fileList: [],
      scanSrc: "",
      excelCont: {
        header: [],
        items: []
      }, // excel内容
      qrCodeShow: false,
      orgUrl: ""
    };
  },

  components: {
    viewTitle
  },

  mixins: [mixinOrgUrl],

  computed: {
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    },
    domain() {
      return this.$route.query.domain;
    },
    comId() {
      return this.$route.query.comId;
    },
    appId() {
      return this.$route.query.appId;
    }
  },

  mounted() {},

  async activated() {},

  async created() {
    this.orgUrl = await this.mixinOrgUrlSet("sysAdmin");
    this.getCategoryList();
    this.getDetail();
  },

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str)).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str)).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str)).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 获取类别列表
    async getCategoryList() {
      let dataObj = await this.$common.http({
        url: "/api/psummary/admin/list_class",
        data: {
          page: 1,
          page_size: 9999999
        }
      });
      let obj = dataObj.data.data;
      obj.items.forEach(item => {
        this.categoryOptions.push(item);
      });
    },

    // 确认删除
    confirm() {
      this.dialogParams.show = false;
      this.$common
        .http({
          url: "/api/psummary/admin/delete_summary",
          data: {
            id: this.id
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("删除成功");
          setTimeout(() => {
            this.$router.history.go(-1);
          }, 1500);
        });
    },

    // 预览
    onPre() {
      this.qrCodeShow = true;
      let url = `${this.domain}/rhwx/index.html#/rhwxApprovalInfo?id=${this.id}&type=list&com_id=${this.comId}&app_id=process_pass`;
      console.log(url);
      setTimeout(() => {
        document.getElementById("qrcode").innerHTML = "";
        new QRCode("qrcode", {
          text: url,
          width: 260,
          height: 260
        });
      }, 100);
    },

    // 获取详情
    getDetail() {
      if (this.id) {
        this.$common
          .http({
            url: "/api/psummary/admin/detail_summary",
            data: {
              id: this.id
            }
          })
          .then(res => {
            console.log(res);
            let obj = res.data.data;
            this.params.title = obj.title;
            this.params.class_id = obj.class_id;
            this.params.publish_timing = Number(obj.publish_timing) * 1000;
            this.params.file.file_name = obj.file_name;
            this.params.class_name = obj.class_name;
            this.excelCont.items = obj.situation;
            for (let key in obj.situation[0]) {
              this.excelCont.header.push(key);
            }
            this.$common
              .http({
                url: this.orgUrl.getInitData,
                data: {
                  depts: obj.dept_list,
                  users: obj.user_list,
                  tags: obj.group_list
                }
              })
              .then(res1 => {
                console.log(res1);
                let obj1 = res1.data.data;
                this.listSuperAdmin = {
                  org: obj1.depts,
                  group: obj1.tags,
                  user: obj1.users
                };
                this.deptListObj.pluginResult.select = {
                  org: obj1.depts,
                  group: obj1.tags,
                  user: obj1.users
                };
              });
          });
      }
    },

    // 再次发送(编辑)
    modifyInfo() {
      this.$router.push({
        path: "/rhqy/service/approval/info/modify",
        query: {
          type: "edit",
          id: this.id
        }
      });
    },

    // 确认删除
    confirmDel() {
      this.dialogParams.show = false;
      this.$common
        .http({
          url: "/api/psummary/admin/delete_summary",
          data: {
            id: this.id
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("删除成功");
          setTimeout(() => {
            this.$router.history.go(-1);
          }, 1500);
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.approvalInfoModify {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 16px;
  overflow: auto;
  .viewTitle {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 16px 0 16px;
    height: 59px;
    border-bottom: 1px solid #e4e4e4;
  }
  .listAdmin {
    padding: 16px;
    > p {
      margin: 0;
    }
  }
  .adminItem {
    margin-right: 10px;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
